export default __webpack_public_path__ + "static/media/logo-2.5b3a09fd.png";